import { EmployeesEmployeeSelectorInput } from 'generated/resources/graphql'

import { EmployeeSelectorV2 } from 'modules/employees/components/EmployeeSelectorV2'

interface Props {
  selection: EmployeesEmployeeSelectorInput
  setSelection: (selection: EmployeesEmployeeSelectorInput) => void
}

const ResourceTypes = ({ selection, setSelection }: Props) => {
  return (
    <EmployeeSelectorV2
      multiple
      value={selection.type === 'manual' ? (selection.ids ?? []) : []}
      onChange={setSelection}
      options={{ asList: true }}
    />
  )
}
export default ResourceTypes
